import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@/helpers/api';
import ActivityService from '@/services/TourServices/ActivityService';
import { types, actions } from './reducer';

function* deleteActivity({ id }) {
    try {
        yield call(ActivityService.deleteOne, id);
        yield put(actions.deleteActivitySucceeded(id, 'activity deleted successfully'));
    } catch (error) {
        yield put(actions.deleteActivityFailed(extractError(error)));
    }
}

function* watchDeleteActivity() {
    yield takeEvery(
        types.REQUEST_DELETE_ACTIVITY,
        deleteActivity,
    );
}

function* activityDeleteSaga() {
    yield all([
        fork(watchDeleteActivity),
    ]);
}

export default activityDeleteSaga;
